import { useContext } from "react";

import {
  CookieConsentContext,
  type CookieConsentContextValue,
} from "@punto/frontend-shared/providers/cookie-consent-provider";

export const useCookieConsent = (): CookieConsentContextValue => {
  const context = useContext(CookieConsentContext);

  if (!context) {
    throw new Error(
      "useCookieConsent must be used within a CookieConsentProvider",
    );
  }

  return context;
};
